module.exports = __webpack_public_path__ + "static/data/tracking.98ac05d.json";


//////////////////
// WEBPACK FOOTER
// ./src/config/tracking.json
// module id = jUnm
// module chunks = 1